import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAuth from './auth.reducer';

const selectAuthState = createFeatureSelector<fromAuth.State>(
  fromAuth.featureKey
);

export const selectIsLoadingUser = createSelector(
  selectAuthState,
  fromAuth.getIsLoadingUser
);

export const selectIsLoadingPublicTokens = createSelector(
  selectAuthState,
  fromAuth.getIsLoadingPublicTokens
);

export const selectIsLoadingOUVLayers = createSelector(
  selectAuthState,
  fromAuth.getIsLoadingOUVLayers
);

export const selectUser = createSelector(selectAuthState, fromAuth.getUser);
export const selectUserPermissions = createSelector(
  selectAuthState,
  fromAuth.getUserPermissions
);

export const selectPublicTokens = createSelector(
  selectAuthState,
  fromAuth.getPublicTokens
);

export const selectAuthError = createSelector(
  selectAuthState,
  fromAuth.getAuthError
);
